/**
 *
 * @module drmType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef DrmType
 * @type {Object}
 *
 * @property {String} NONE - Used to signify that no DrmType is available.
 * @property {String} SILK - SILK is the existing encryption key mechanism.
 * @property {String} PLAYREADY - PlayReady is the Microsoft content encryption standard.
 * @property {String} WIDEVINE - Widevine is Google's content encryption standard.
 * @property {String} FAIRPLAY - FairPlay is the Apple content encryption standard.
 *
 */

/**
 *
 * @enum
 * @type {DrmType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    NONE: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    SILK: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    PLAYREADY: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    WIDEVINE: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    FAIRPLAY: null
});




// WEBPACK FOOTER //
// ./src/services/media/drmType.js